// myPlugin.js
import Vue from 'vue'
const MyPlugin = {};

MyPlugin.install = function (Vue, options) {
  Vue.prototype.$money = function (money) {
    return ((Number(money) ? Number(money) : 0) / 100).toFixed(2)
  };
  Vue.prototype.$multiplication = function (money) {
    return Number(((Number(money) ? Number(money) : 0) * 100).toFixed(2))
  };
  // 获取当前时间的时间方法
  Vue.prototype.$getCurrent = function (type) {
    var currentDate = new Date();
    var year = currentDate.getFullYear();
    var month = currentDate.getMonth() + 1;
    var day = currentDate.getDate();
    var day2 = currentDate.getDate() - 1;
    var hours = currentDate.getHours();
    var minutes = currentDate.getMinutes();
    var seconds = currentDate.getSeconds();
    month = String(month).padStart(2, '0');
    day = String(day).padStart(2, '0');
    hours = String(hours).padStart(2, '0');
    minutes = String(minutes).padStart(2, '0');
    seconds = String(seconds).padStart(2, '0');
    if (type == 1)
      return `${year}-${month}-${day}`;
    if (type == 2)
      return `${year}-${month}-${day2}`;
    else
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  Vue.prototype.$findChildren = function (parent_id, data) {
    // 这是一个递归方法，可以在整个应用程序中使用
    const children = data.filter(item => item.parent_id == parent_id);
    children.forEach(child => {
      child.label = child.name;
      if (this.$findChildren(child.id, data).length > 0) {
        child.children = this.$findChildren(child.id, data);
      } else {
        delete child.children;
      }
    });
    return children;
  };

  Vue.prototype.$post = function (url, data) {
    return this.$http({
      method: 'post',
      url: url,
      data: data
    });
  };

  Vue.prototype.$get = function (url, params) {
    return this.$http({
      method: 'get',
      url: url,
      params: params
    });
  };

};

export default MyPlugin;




// WEBPACK FOOTER //
// ./src/utils/customMethod.js